// import JS files
// import JS files
import '../kickstart';
import { h, render } from 'preact';
import select from '../utils/select';
import selectAll from '../utils/select-all';

// Components
import App from '../ResultsApp';
import loadJsonScript from '../utils/load-json-script';

const annotations = loadJsonScript('annotations_data');

render(<App annotations={annotations} />, document.getElementById('app'));

// Navigation bar at the top

const appNav = document.getElementById('app-nav');
const { height } = appNav.getBoundingClientRect();
const appNavHeight = Math.round(height) + 10;

const appNavJumps = selectAll('.navbar__item a', appNav);

appNavJumps.forEach(el => {
  el.addEventListener('click', e => {
    e.preventDefault();
    const target = select(e.target.getAttribute('href'));

    // var current = appNav.getElementsByClassName('active-nav');

    // current[0].className = current[0].className.replace(' active-nav', '');

    // var path =
    //   e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
    // path[1].className += ' active-nav';

    window.scrollTo(
      0,
      window.pageYOffset + target.getBoundingClientRect().top - appNavHeight
    );
  });
});

// Race to Watch buttons

// filterSelection('all');
// function filterSelection(c, id) {
//   var x, i;
//   x = document.querySelectorAll(
//     '#' + String(id) + ' .contests .office__contests > .seat'
//   );

//   // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
//   for (i = 0; i < x.length; i++) {
//     if (c == 'all') {
//       w3RemoveClass(x[i], 'remove');
//     } else {
//       w3RemoveClass(x[i], 'remove');
//       if (x[i].getElementsByClassName('office__flag').length == 0)
//         w3AddClass(x[i], 'remove');
//     }
//   }
// }

// // Show filtered elements
// function w3AddClass(element, name) {
//   var i, arr1, arr2;
//   arr1 = element.className.split(' ');
//   arr2 = name.split(' ');
//   for (i = 0; i < arr2.length; i++) {
//     if (arr1.indexOf(arr2[i]) == -1) {
//       element.className += ' ' + arr2[i];
//     }
//   }
// }

// // Hide elements that are not selected
// function w3RemoveClass(element, name) {
//   var i, arr1, arr2;
//   arr1 = element.className.split(' ');
//   arr2 = name.split(' ');
//   for (i = 0; i < arr2.length; i++) {
//     while (arr1.indexOf(arr2[i]) > -1) {
//       arr1.splice(arr1.indexOf(arr2[i]), 1);
//     }
//   }
//   element.className = arr1.join(' ');
// }

// // Add active class to the current control button (highlight it)
// var btnContainer = document.querySelectorAll('#btnGroup');

// for (var i = 0; i < btnContainer.length; i++) {
//   var btns = btnContainer[i].getElementsByClassName('button');

//   for (var t = 0; t < btns.length; t++) {
//     btns[t].addEventListener('click', function(event) {
//       var path =
//         event.path ||
//         (event.composedPath && event.composedPath()) ||
//         composedPath(event.target);

//       var currentParent = document.querySelector(
//         '#btnGroup.' + path[1].className
//       );
//       var current = currentParent.getElementsByClassName('active');
//       current[0].className = current[0].className.replace(' active', '');
//       this.className += ' active';
//       filterSelection(this.value, path[2].id);
//     });
//   }
// }

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}
